import { styled } from '@goodfynd/theme';
import { Alert, Button, Text } from '@goodfynd/ui';

import NextEventInfo from '../../NextEventInfo';

export const StyledBlock = styled('aside', {
  alignItems: 'center',
  display: 'flex',
  gap: 12,
  marginTop: 8,
  '@lg': {
    marginTop: 0,
  },
  '+ aside': {
    marginTop: 16,
    '@lg': {
      marginTop: 0,
    },
    minWidth: 'fit-content',
  },
});

export const StyledButton = styled(Button, {
  display: 'inline',
  borderRadius: 4,
  boxShadow: 'none',
});

export const StyledContainer = styled('section', {
  alignItems: 'flex-start',
  gap: 16,
  justifyContent: 'space-between',
  marginTop: 16,
  width: '100%',
  '@sm': {
    padding: '0 16px',
  },
  '@lg': {
    display: 'flex',
  },
});

export const StyledCta = styled(Button, {
  width: 175,
  '+ button': {
    width: 160,
  },
});

export const StyledCtaContainer = styled('aside', {
  display: 'flex',
  '> button + button': {
    marginLeft: 8,
  },
});

export const StyledNextEventInfo = styled(NextEventInfo, {
  '@sm': {
    marginTop: 24,
  },
  '@md': {
    marginTop: 32,
  },
  '@lg': {
    marginTop: 48,
  },
});

export const StyledName = styled(Text, {
  fontSizeRem: 26,
  fontWeight: 800,
  lineHeightRem: 32,
  margin: 0,
  '@lg': {
    fontSizeRem: 36,
    lineHeightRem: 48,
  },
});

export const StyledQuickInfo = styled('div', {
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
});

export const StyledDescription = styled(Text, {
  marginTop: 18,
});

export const StyledAlert = styled(Alert, {});
